var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateDesktopImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 300,
    viewBox: "0 0 253 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127 40.0977V65.1373L116.179 69.7029V108.671L127.674 120.167V141.673H51.1526V104.927L60.2737 78.9499L80.1579 55.7797L105.889 42.4357L127 40.0977Z",
    fill: "url(#paint0_linear_282_3508)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127 36C171.163 36.0474 206.953 71.8559 207 116.043V208.723C207 252.931 171.184 288.766 127 288.766C82.8158 288.766 47 252.931 47 208.723V116.043C47.0474 71.8559 82.8368 36.0474 127 36ZM118.579 78.1277V103.404C118.579 108.059 122.347 111.83 127 111.83C131.653 111.83 135.421 108.059 135.421 103.404V78.1277C135.421 73.4726 131.653 69.7022 127 69.7022C122.347 69.7022 118.579 73.4726 118.579 78.1277ZM198.579 116.043C198.516 78.1646 169 46.8848 131.211 44.6414V61.8769C138.626 63.7938 143.816 70.471 143.842 78.1277V103.404C143.816 111.066 138.626 117.743 131.211 119.655V137.106H198.579V116.043ZM55.4211 208.723C55.4632 248.26 87.4842 280.298 127 280.34C166.516 280.298 198.537 248.26 198.579 208.723V145.532H55.4211V208.723ZM55.4211 137.106H122.789V119.655C115.374 117.738 110.184 111.061 110.158 103.404V78.1277C110.184 70.4657 115.374 63.7885 122.789 61.8769V44.6414C85 46.8848 55.4842 78.1698 55.4211 116.043V137.106Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_3508",
    x1: 127.674,
    y1: 40.0977,
    x2: 124.95,
    y2: 143.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#687D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE3E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateDesktopImg);
export default __webpack_public_path__ + "static/media/rotate-desktop_img.b8294999580da58567f2923fd7359e81.svg";
export { ForwardRef as ReactComponent };